export const ACCREDITATIONREVIEW = '/accreditationtechnicalreview';

export const ACCREDITATIONS_APPLICATIONS = '/accreditationtechnicalreview/accreditations';

export const ORGANIZATIONS = '/organizationstechnicalreview';

export const COMMON_POLITICAL_DIVISION = '/common/politicalDivisiontechnicalreview';

export const DETAILS = '/detailstechnicalreview';

export const ANNEXES = '/annexestechnicalreview';

export const REQUEST = '/request';

export const COMPLIANCE_COMMITMENT = '/complianceCommitmenttechnicalreview';

export const DECLARATION_START_PROCCESS = '/declarationsStartProccess';

export const SEND_REQUEST = '/sendRequesttechnicalreview';

export const PLANNING_TEAM = '/accreditationtechnical/planningteam';

export const ANALYSIS_OBJETION = '/accreditationtechnical/evaluationobjetion';

export const EVALUATION_DOCUMENTAL = '/accreditationtechnical/evaluationdocumental';

export const EVALUATION_TESTIFICATION = '/accreditationtechnical/approvalEvaluationPlan';

export const ACCREDITATIONS_QUOTATIONS = '/accreditationtechnical/quotations';

export const NON_CONFORMITIES = '/accreditationtechnical/nonconformities';

export const REVIEW_CORRECTIVE_ACTIONS_TECHNICAL = '/accreditationtechnical/nonConformitiesReviewCorrectiveActions';

export const INSTANCE_MEMBERS_REVIEW = '/accreditationtechnical/instanceMembersReview';

export const REVIEW_DOCUMENTARY_REPORT = '/accreditationtechnical/reviewDocumentaryReport';

export const TECHNICAL_ANALYSIS_REPORT = '/accreditationtechnical';

export const DIRECTOR_AREA_REPORT = '/accreditationtechnical/decisionDirectorFile';

export const TECHNICAL_COORDINATION_REPORT = '/accreditationtechnical/generalTechnicalCoordination';

export const EXECUTIVE_DIRECTOR_ACREDITATION = '/accreditationexecutive/accreditations';

export const DESICION_MAKING = '/accreditationtechnical/desicionmaking';

export const REVISION_ACTION_PLAN = '/accreditationtechnical/revision/action-plan';
